import { capitalize } from 'lodash'

// Display labels for benchmark scopes, where the label shown on a chart differs from a
// plain capitalisation of the scope key. The key is what the benchmark data, the series
// colour palette and the series ordering all match on, so anywhere a label can be read
// back as an identifier has to normalise it through benchmarkScopeKey first.
const SCOPE_LABELS = {
    industry: 'Global',
}

const LABEL_SCOPES = Object.entries(SCOPE_LABELS).reduce((map, [scope, label]) => (
    Object.assign(map, { [label.toLowerCase()]: scope })
), {})

export const benchmarkScopeLabel = (scope) => {
    if (scope == null) return scope
    return SCOPE_LABELS[String(scope).toLowerCase()] ?? capitalize(scope)
}

// Renames a series whose name is a benchmark scope, leaving every other name untouched.
// Unlike benchmarkScopeLabel this never re-cases an unrecognised name, so it is safe to
// apply to series names that arrive straight from the API alongside non-scope names.
export const benchmarkSeriesLabel = (name) => {
    if (name == null) return name
    return SCOPE_LABELS[String(name).toLowerCase()] ?? name
}

// Accepts either a scope key or a display label and returns the scope key.
export const benchmarkScopeKey = (scopeOrLabel) => {
    if (scopeOrLabel == null) return scopeOrLabel
    const lowered = String(scopeOrLabel).toLowerCase()
    return LABEL_SCOPES[lowered] ?? lowered
}
